import type { SVGProps } from 'react'
const LineTaxi = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M20.425 9H22v1.5h-1.175l.175.65v6.6c0 .69-.56 1.25-1.25 1.25H18.5v2H17v-2H7v2H5.5v-2H4.25C3.56 19 3 18.44 3 17.75v-6.6l.175-.65H2V9h1.575l1.09-4.075C4.815 4.38 5.31 4 5.875 4H9.5V2.5h5V4h3.625c.565 0 1.065.38 1.21.925zM17.93 5.5H6.065l-1.34 5H19.27zM4.5 15.5v2h15v-2H17V14h2.5v-2h-15v2H7v1.5zm5-1.5h5v1.5h-5z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineTaxi }
